var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendAcw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 3C20.6 3 22.6 4.9 22.6 12.8C22.6 20.7 20.6 22.6 12.8 22.6C5 22.6 3 20.6 3 12.8C3 5 5 3 12.8 3Z",
    stroke: "currentColor",
    strokeWidth: 2.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 11.3016C11.8 11.3016 10.9 11.5016 10 11.7016V13.6016C10 13.8016 9.9 14.1016 9.7 14.2016C9.1 14.5016 8.6 14.9016 8.1 15.3016C8 15.4016 7.8 15.5016 7.7 15.5016C7.5 15.5016 7.4 15.4016 7.3 15.3016L5.6 13.8016C5.5 13.7016 5.5 13.7016 5.5 13.6016C5.5 13.5016 5.5 13.4016 5.5 13.4016C5.5 13.2016 5.6 13.1016 5.7 13.0016C7.6 11.2016 10.1 10.1016 12.9 10.1016C15.7 10.1016 18.2 11.2016 20.1 13.0016C20.2 13.1016 20.3 13.3016 20.3 13.4016C20.3 13.6016 20.2 13.7016 20.1 13.8016L18.6 15.3016C18.5 15.4016 18.3 15.5016 18.2 15.5016C18 15.5016 17.9 15.4016 17.8 15.3016C17.3 14.8016 16.8 14.5016 16.2 14.2016C16.1 14.1016 16 14.1016 15.9 14.0016C15.8 13.9016 15.8 13.8016 15.8 13.7016V11.8016C14.7 11.5016 13.8 11.3016 12.8 11.3016Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendAcw);
export default __webpack_public_path__ + "static/media/LegendACW.3fbb8d7eee1324a69272c2f5b3eedb5d.svg";
export { ForwardRef as ReactComponent };